import React from "react";
import createSvgIcon from "./createSvgIcon";

export default createSvgIcon(
  <path d="M28.21,14.93a.69.69,0,0,1-.13.36l-1.2,1.45a.62.62,0,0,1-.43.2.61.61,0,0,1-.36-.13l-11-9.08a.62.62,0,0,0-.35-.12.65.65,0,0,0-.36.12l-11,9.08a.57.57,0,0,1-.36.13.64.64,0,0,1-.43-.2l-1.2-1.46a.63.63,0,0,1-.13-.35.68.68,0,0,1,.21-.44L13.27,4.72a2.67,2.67,0,0,1,1.43-.51,2.61,2.61,0,0,1,1.43.51l4.2,3.45V4.77a.56.56,0,0,1,.56-.56h2.63a.56.56,0,0,1,.56.56v6.49L28,14.49A.68.68,0,0,1,28.21,14.93Zm-13.5-5.4a.62.62,0,0,1,.35.12l8.65,7.12v7.68a.75.75,0,0,1-.75.75H17.7a.76.76,0,0,1-.75-.75h0V20a.75.75,0,0,0-.75-.75h-3a.76.76,0,0,0-.75.75v4.49a.75.75,0,0,1-.74.75H6.46a.74.74,0,0,1-.75-.75V16.77l8.64-7.12A.65.65,0,0,1,14.71,9.53Z" />,
  "Home",
  "0 0 29.41 29.41"
);
